import { customElement } from 'lit/decorators.js';
import { html, LitElement } from 'lit';

@customElement('icon-plus')
export class IconPlus extends LitElement {
  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
  render() {
    return html`<i class="fa-solid fa-square-plus"></i>`;
  }
}
